@if (lastGamePlay) {
  <section class="sm-pad-tb">
    <div id="last-play-title-row" class="last-play-row">
      <span class="item-title">{{ 'components.lastPlaySection.title' | transloco }}</span><span
    class="item-value">{{ lastGamePlay.playType }}</span>
  </div>
  <div class="last-play-row">
    <div>
      <span class="item-title">Result</span>
      <span class="item-value">{{ lastGamePlay.result }}</span>
    </div>
    @if (lastGamePlay.playType !== 'KO') {
      <div>
        <span class="item-title">Gain/Lost</span>
        <span class="item-value">{{ lastGamePlay.gnLs }}</span>
      </div>
    }
    @if (lastGamePlay.playType === 'KO') {
      <div>
        <span class="item-title">Kick yards</span>
        <span class="item-value">{{ lastGamePlay.kickYards }}</span>
      </div>
    }
    @if (lastGamePlay.playType === 'KO') {
      <div>
        <span class="item-title">Return yards</span>
        <span class="item-value">{{ lastGamePlay.returnYards }}</span>
      </div>
    }
  </div>
  <div class="last-play-row">
    <div>
      <span class="item-title">ODK</span><span class="item-value">{{ lastGamePlay.odk }}</span>
    </div>
    <div>
      <span class="item-title">Down</span><span class="item-value">{{ lastGamePlay.down }}</span>
    </div>
    <div>
      <span class="item-title">Distance</span><span class="item-value">{{ lastGamePlay.distance }}</span>
    </div>
    <div>
      <span class="item-title">Yardline</span><span class="item-value">{{ lastGamePlay.yardLine }}</span>
    </div>
    <div>
      <span class="item-title">Hash</span><span class="item-value">{{ lastGamePlay.hash }}</span>
    </div>
  </div>
  @if (lastGamePlay.penTeam) {
    <div class="last-play-row">
      <div>
        <span class="item-title penalty-item">Penalty on</span>
        <span class="item-value penalty-item">{{ lastGamePlay.penTeam }}</span>
      </div>
      <div>
        <span class="item-title penalty-item">Penalty yards</span>
        <span class="item-value penalty-item">{{ lastGamePlay.penYards }}</span>
      </div>
    </div>
  }
  <div class="last-play-row">
    @if (rusher) {
      <div>
        <span class="item-title">Rusher</span>
        <span class="item-value">{{ rusher }}</span>
      </div>
    }
    @if (passer) {
      <div>
        <span class="item-title">Passer</span>
        <span class="item-value">{{ passer }}</span>
      </div>
    }
    @if (receiver) {
      <div>
        <span class="item-title">Receiver</span>
        <span class="item-value">{{ receiver }}</span>
      </div>
    }
    @if (battedDown) {
      <div>
        <span class="item-title">Batted down</span>
        <span class="item-value">{{ battedDown }}</span>
      </div>
    }
    @if (kicker) {
      <div>
        <span class="item-title">Kicker</span>
        <span class="item-value">{{ kicker }}</span>
      </div>
    }
    @if (returner) {
      <div>
        <span class="item-title">Returner</span>
        <span class="item-value">{{ returner }}</span>
      </div>
    }
    @if (tackler1 || tackler2) {
      <div>
        <span class="item-title">Tacklers</span>
        <span class="item-value">{{ tackler1 }}{{ !tackler2 ? "" : ", " + tackler2 }}</span>
      </div>
    }
    @if (forcedFumbleBy) {
      <div>
        <span class="item-title">Forced fumble by</span>
        <span class="item-value">{{ forcedFumbleBy }}</span>
      </div>
    }
    @if (recoveredBy) {
      <div>
        <span class="item-title">Recovered by</span>
        <span class="item-value">{{ recoveredBy }}</span>
      </div>
    }
    @if (interceptedBy) {
      <div>
        <span class="item-title">Intercepted by</span>
        <span class="item-value">{{ interceptedBy }}</span>
      </div>
    }
  </div>
</section>
}
